import React from 'react';
import { firestore } from '../../contexts/FirebaseContext';

function useTickets() {
  const reportTicket = async (dataTicket) => {
    await firestore.collection('tickets').add(dataTicket);
  };
  return { reportTicket };
}

export default useTickets;
